// PostgREST de Supabase tiene `max-rows = 1000`. Cualquier .select() sin
// filtro estrecho ni .range() iterativo se trunca silenciosamente al
// llegar a esa cantidad. Este helper itera en chunks de 1000 hasta
// recibir una página parcial.

const PAGE_SIZE = 1000;

type RangeQuery<T> = PromiseLike<{ data: T[] | null; error: any }>;

export async function paginateQuery<T>(
  build: (from: number, to: number) => RangeQuery<T>,
  pageSize: number = PAGE_SIZE,
  orderColumn: string | null = 'id',
): Promise<T[]> {
  const out: T[] = [];
  let page = 0;
  while (true) {
    let q: any = build(page * pageSize, (page + 1) * pageSize - 1);
    // CRÍTICO: garantizar un ORDER BY estable para que LIMIT/OFFSET sea
    // determinístico. Sin un orden fijo, Postgres devuelve las páginas en
    // orden indefinido y entre ellas se PIERDEN/DUPLICAN filas → conteos y
    // listados por debajo del real (bug real: contenido 49% en vez de 100%).
    // Por defecto encadenamos `.order('id')`; si el caller ya ordenó por una
    // columna de display, `id` queda como desempate y preserva ese orden.
    // Si la tabla no tuviera columna `id`, pasar orderColumn = null y ordenar
    // manualmente por una columna única antes de invocar el helper.
    if (orderColumn && typeof q?.order === 'function') {
      q = q.order(orderColumn);
    }
    const { data, error } = await q;
    if (error) throw error;
    if (!data || data.length === 0) break;
    out.push(...data);
    if (data.length < pageSize) break;
    page++;
  }
  return out;
}
